import * as React from "react";
import {cx} from "emotion";

import "./details-modal.scss";

import {cs}            from "@Common/react/chain-services";
import {keyed}         from "@Common/react/keyed";
import {UseState}      from "@Common/react/use-state";
import {formatMoney}   from "@Common/ui-components/language/format-money";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

import {BalanceHistory}    from "./balance-history/balance-history";
import {OrderUsageHistory} from "./order-usage-history/order-usage-history";

export const DetailsModal = ({next: rootNext}) => cs(
    ["modal", (_, next) => ModalService3({
        xdQaName: "Details Modal",
        sidebar: true,
        // initShow: isDevQuan(),
        width: 459,
        next,
        rootNext,
    })],
    ["tab", (_, next) => UseState({
        initValue: "order-usage",
        next,
    })],
    ({tab, modal: {params: voucher}}) => (
        <div className="details-modal details-modal-6fz">
            <div className="header">
                <div className="left">
                    <div className="label" xd-qa-type="label" xd-qa-name="Available in">
                        Available in
                    </div>
                    <div className="title" title={`${voucher.name} Program`} xd-qa-type="text" xd-qa-name={voucher.name + " Program"}>
                        {voucher.name} Program
                    </div>
                </div>

                <div className="right" xd-qa-type="text" xd-qa-name="Amount">
                    {formatMoney(voucher.total, {useFreeLabel: false})}
                </div>
            </div>

            <div className="tabs">
                {[
                    {
                        label: "Order Usage History",
                        value: "order-usage",
                    },
                    {
                        label: "Balance History",
                        value: "balance",
                    },
                ].map(({label, value}) => (
                    <div
                        className={cx("item", {active: value === tab.value})}
                        onClick={() => tab.onChange(value)}
                        key={value}
                        xd-qa-type="label"
                        xd-qa-name={label}
                    >
                        {label}
                    </div>
                ))}
            </div>

            <div className="content">
                {cs(
                    keyed(tab.value),
                    () => tab.value === "order-usage" ? (
                        OrderUsageHistory({voucher})
                    ) : (
                        BalanceHistory({voucher})
                    ),
                )}
            </div>
        </div>
    ),
);
